import React, { useState, useMemo } from 'react';
import PageHeader from "../BomManagement/components/PageHeader";

// 1. CSS 스타일 정의 (전체 화면 꽉 차게 수정)
const globalStyles = `
  :root {
    --main-bg: #f3f4f6;
    --white: #ffffff;
    --primary: #3b82f6;
    --primary-hover: #2563eb;
    --text-dark: #1f2937;
    --text-light: #6b7280;
    --border: #e5e7eb;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Noto Sans KR', sans-serif;
  }

  body {
    background-color: var(--main-bg);
  }

  .app-container {
    display: flex;
    flex-direction: column; /* 세로 배치로 변경하여 헤더/본문 구조 잡기 용이하게 */
    height: 100vh;
    background-color: var(--main-bg);
    color: var(--text-dark);
    width: 100%; /* 전체 너비 */
  }

  /* 메인 컨텐츠 영역 - 너비 제한(max-width) 제거 */
  main {
    flex: 1;
    width: 100%;       /* 화면 꽉 채우기 */
    padding: 0px;     /* BomManagement와 유사한 여백 */
    overflow-y: auto;
  }

  header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }

  h1 {
    font-size: 24px;
    font-weight: bold;
    color: var(--text-dark);
  }

  /* 탭 버튼 */
  .category-tabs {
    margin-bottom: 20px;
    display: flex;
    gap: 10px;
  }

  .tab-btn {
    padding: 10px 20px;
    border: 1px solid var(--border);
    background: white;
    border-radius: 8px;
    cursor: pointer;
    font-weight: bold;
    color: var(--text-light);
    transition: 0.2s;
  }

  .tab-btn.active {
    background-color: var(--primary);
    color: white;
    border-color: var(--primary);
  }

  /* 카드 및 테이블 */
  .card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06); /* MUI 그림자 느낌 */
    padding: 24px;
    margin-bottom: 24px;
    width: 100%; /* 카드도 꽉 차게 */
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    table-layout: fixed; /* 컬럼 너비 고정으로 깔끔하게 */
  }

  th {
    text-align: left;
    padding: 16px;
    color: var(--text-light);
    font-size: 13px;
    font-weight: 600;
    border-bottom: 1px solid var(--border);
    background-color: #f9fafb;
  }

  td {
    padding: 16px;
    border-bottom: 1px solid var(--border);
    font-size: 14px;
    vertical-align: middle;
  }

  tr:hover td {
    background-color: #f9fafb;
    cursor: pointer;
  }

  .status-badge {
    padding: 4px 10px;
    border-radius: 9999px;
    font-size: 12px;
    font-weight: 600;
    background-color: #d1fae5;
    color: #065f46;
  }

  .btn-order {
    padding: 6px 14px;
    background-color: var(--primary);
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;
    transition: background-color 0.2s;
  }
  
  .btn-order:hover {
    background-color: var(--primary-hover);
  }

  .btn-order-header {
    background: #10b981; 
    padding: 10px 24px; 
    font-size: 14px;
    font-weight: 600;
    border: none;
    border-radius: 8px;
    color: white;
    cursor: pointer;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  }
  
  .btn-order-header:hover {
    background-color: #059669;
  }

  /* 모달 공통 */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    backdrop-filter: blur(2px); /* 배경 블러 효과 추가 */
  }

  .modal {
    background: white;
    width: 500px;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .modal.large {
      width: 700px; /* 주문서 모달 약간 더 넓게 */
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    border-bottom: 1px solid var(--border);
    padding-bottom: 16px;
  }

  .modal-title {
    font-size: 20px;
    font-weight: bold;
    color: var(--text-dark);
  }

  .close-btn {
    cursor: pointer;
    font-size: 24px;
    color: var(--text-light);
    line-height: 1;
  }
  
  .close-btn:hover {
    color: var(--text-dark);
  }

  .modal-image-container {
    width: 100%;
    height: 250px;
    background: #f3f4f6;
    margin-bottom: 24px;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--border);
  }

  .modal-image-container img {
    width: 100%;
    height: 100%;
    object-fit: contain; /* 이미지가 잘리지 않고 다 보이도록 변경 */
    transition: transform 0.3s;
  }

  .modal-image-container img:hover {
    transform: scale(1.05);
  }

  .info-row {
    display: flex;
    justify-content: space-between; /* 좌우 정렬 */
    margin-bottom: 12px;
    font-size: 15px;
    padding: 0 4px;
  }

  .info-row .label {
    color: var(--text-light);
    font-weight: 500;
  }

  .info-row .value {
    font-weight: bold;
    color: var(--text-dark);
  }

  .input-group {
    margin-top: 24px;
    padding: 16px;
    background: #f9fafb;
    border-radius: 8px;
    border: 1px solid var(--border);
  }

  .input-group label {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-dark);
  }

  .input-qty {
    width: 100%;
    padding: 10px;
    border: 1px solid var(--border);
    border-radius: 6px;
    font-size: 16px;
    outline: none;
  }
  
  .input-qty:focus {
    border-color: var(--primary);
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
  }

  .total-price-area {
    margin-top: 20px;
    text-align: right;
    font-size: 20px;
    font-weight: 800;
    color: var(--primary);
  }

  .modal-footer {
    margin-top: 30px;
    display: flex;
    gap: 12px;
  }

  .btn-full {
    flex: 1;
    padding: 14px;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    font-size: 15px;
    cursor: pointer;
    transition: 0.2s;
  }

  .btn-cancel {
    background: white;
    color: var(--text-dark);
    border: 1px solid var(--border);
  }
  
  .btn-cancel:hover {
    background: #f9fafb;
  }

  .btn-confirm {
    background: var(--primary);
    color: white;
  }
  
  .btn-confirm:hover {
    background: var(--primary-hover);
  }

  .order-action-area {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    padding-top: 20px;
    border-top: 1px solid var(--border);
  }

  .btn-final-order {
    background-color: #111827;
    color: white;
    padding: 14px 40px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: bold;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    transition: all 0.2s;
  }

  .btn-final-order:hover {
    background-color: #374151;
    transform: translateY(-1px);
  }

  /* 주문서 테이블 */
  .invoice-table {
    width: 100%;
    border: 1px solid var(--border);
    margin-bottom: 24px;
  }

  .invoice-table th {
    background: #f3f4f6;
    text-align: center;
    border-bottom: 1px solid var(--border);
    padding: 12px;
  }

  .invoice-table td {
    text-align: center;
    border-bottom: 1px solid var(--border);
    padding: 12px;
  }

  .invoice-summary {
    text-align: right;
    font-size: 22px;
    font-weight: bold;
    margin-top: 24px;
    color: var(--text-dark);
    border-top: 2px solid var(--text-dark);
    padding-top: 16px;
  }

  .empty-msg {
      text-align: center;
      color: #999;
      padding: 40px 0;
      font-size: 15px;
  }
`;

// 2. 데이터 정의
const PRODUCTS_DATA = {
    print: [
        { code: 'PRT-001', vendor: '에잇핀', name: '고급 인쇄용지 (A4/Box)', price: 25000, imageUrl: 'https://images.unsplash.com/photo-1586075010923-2dd4570fb338?auto=format&fit=crop&w=600&q=80' },
        { code: 'PRT-002', vendor: '에잇핀', name: '전사용지 (백색/롤)', price: 45000, imageUrl: 'https://images.unsplash.com/photo-1517454231627-380d6f2845c4?auto=format&fit=crop&w=600&q=80' },
        { code: 'PRT-003', vendor: '에잇핀', name: 'CMYK 잉크 세트 (대용량)', price: 120000, imageUrl: 'https://images.unsplash.com/photo-1542646878-380d0d54f59e?auto=format&fit=crop&w=600&q=80' },
        { code: 'PRT-004', vendor: '에잇핀', name: '인쇄용지 컷팅 서비스 (1건)', price: 5000, imageUrl: 'https://images.unsplash.com/photo-1596230529625-7ee541ad562f?auto=format&fit=crop&w=600&q=80' },
        { code: 'PRT-005', vendor: '에잇핀', name: '친환경 크라프트 포장지', price: 15000, imageUrl: 'https://images.unsplash.com/photo-1606760227091-3dd870d97f1d?auto=format&fit=crop&w=600&q=80' },
        { code: 'PRT-006', vendor: '에잇핀', name: '무광 라미네이팅 필름 (롤)', price: 35000, imageUrl: 'https://images.unsplash.com/photo-1622615433898-d13eb808b073?auto=format&fit=crop&w=600&q=80' },
        { code: 'PRT-007', vendor: '에잇핀', name: '제본용 스프링 (박스)', price: 18000, imageUrl: 'https://images.unsplash.com/photo-1520004434532-3d94d021c27e?auto=format&fit=crop&w=600&q=80' },
        { code: 'PRT-008', vendor: '에잇핀', name: '옵셋 인쇄용 PS판 (10장)', price: 85000, imageUrl: 'https://images.unsplash.com/photo-1629739506692-a725df7f4575?auto=format&fit=crop&w=600&q=80' },
        { code: 'PRT-009', vendor: '에잇핀', name: '팬톤 컬러 가이드 (유/무광)', price: 210000, imageUrl: 'https://images.unsplash.com/photo-1533276537305-6a56e6d152a2?auto=format&fit=crop&w=600&q=80' },
        { code: 'PRT-010', vendor: '에잇핀', name: '대형 재단기 칼날 연마권', price: 30000, imageUrl: 'https://images.unsplash.com/photo-1587840171670-8b850147754e?auto=format&fit=crop&w=600&q=80' }
    ],
    clothes: [
        { code: 'CLT-001', vendor: '에잇핀', name: '자동 제단기 소모품 칼날', price: 8000, imageUrl: 'https://images.unsplash.com/photo-1585824978759-42b78ce75de9?auto=format&fit=crop&w=600&q=80' },
        { code: 'CLT-002', vendor: '에잇핀', name: '최고급 양장용 원단 (야드)', price: 12000, imageUrl: 'https://images.unsplash.com/photo-1612459817769-1250b92d6e35?auto=format&fit=crop&w=600&q=80' },
        { code: 'CLT-003', vendor: '에잇핀', name: '기능성 운동복용 스판덱스', price: 9500, imageUrl: 'https://images.unsplash.com/photo-1579309407335-513227914619?auto=format&fit=crop&w=600&q=80' },
        { code: 'CLT-004', vendor: '에잇핀', name: '100% 천연 실크 원단', price: 35000, imageUrl: 'https://images.unsplash.com/photo-1528458909336-e7a0adfed0a5?auto=format&fit=crop&w=600&q=80' },
        { code: 'CLT-005', vendor: '에잇핀', name: '의류 포장용 폴리백 (100매)', price: 4000, imageUrl: 'https://images.unsplash.com/photo-1595079676614-7836d50225d9?auto=format&fit=crop&w=600&q=80' },
        { code: 'CLT-006', vendor: '에잇핀', name: '고강력 재봉사 (폴리에스터 60수)', price: 2500, imageUrl: 'https://images.unsplash.com/photo-1522026850389-130d2264c767?auto=format&fit=crop&w=600&q=80' },
        { code: 'CLT-007', vendor: '에잇핀', name: 'YKK 지퍼 세트 (혼합/100개)', price: 15000, imageUrl: 'https://images.unsplash.com/photo-1604085420310-859a5893f412?auto=format&fit=crop&w=600&q=80' },
        { code: 'CLT-008', vendor: '에잇핀', name: '의류 부착용 단추 (대용량)', price: 12000, imageUrl: 'https://images.unsplash.com/photo-1605636306540-3498ebc31154?auto=format&fit=crop&w=600&q=80' },
        { code: 'CLT-009', vendor: '에잇핀', name: '의류 심지 (접착식/롤)', price: 6000, imageUrl: 'https://images.unsplash.com/photo-1620799140408-ed5341cd2431?auto=format&fit=crop&w=600&q=80' },
        { code: 'CLT-010', vendor: '에잇핀', name: '케어라벨 인쇄 서비스 (1000장)', price: 25000, imageUrl: 'https://images.unsplash.com/photo-1616600293405-b77242c75a40?auto=format&fit=crop&w=600&q=80' }
    ],
    glasses: [
        { code: 'GLS-001', vendor: '에잇핀', name: 'TR-90 안경 뿔테 원자재 (kg)', price: 18000, imageUrl: 'https://images.unsplash.com/photo-1602160105315-99238f420a96?auto=format&fit=crop&w=600&q=80' },
        { code: 'GLS-002', vendor: '에잇핀', name: '티타늄 안경 다리 부속품 (Set)', price: 5500, imageUrl: 'https://images.unsplash.com/photo-1591076482161-42ce6da69f67?auto=format&fit=crop&w=600&q=80' },
        { code: 'GLS-003', vendor: '에잇핀', name: '실리콘 코받침 부속 (100개)', price: 3000, imageUrl: 'https://images.unsplash.com/photo-1483412919093-03a22057d0d7?auto=format&fit=crop&w=600&q=80' },
        { code: 'GLS-004', vendor: '에잇핀', name: '렌즈 공동 연마기 이용권 (1시간)', price: 20000, imageUrl: 'https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?auto=format&fit=crop&w=600&q=80' },
        { code: 'GLS-005', vendor: '에잇핀', name: '렌즈 로고 레이저 인쇄 서비스', price: 1000, imageUrl: 'https://images.unsplash.com/photo-1563208752-6a84f33168d6?auto=format&fit=crop&w=600&q=80' },
        { code: 'GLS-006', vendor: '에잇핀', name: '아세테이트 시트 (패턴 혼합)', price: 45000, imageUrl: 'https://images.unsplash.com/photo-1618331835717-801e976710b2?auto=format&fit=crop&w=600&q=80' },
        { code: 'GLS-007', vendor: '에잇핀', name: '안경 힌지 나사 (정밀/대용량)', price: 8000, imageUrl: 'https://images.unsplash.com/photo-1511499767150-a48a237f0083?auto=format&fit=crop&w=600&q=80' },
        { code: 'GLS-008', vendor: '에잇핀', name: '초극세사 안경 닦이 (무지/100장)', price: 50000, imageUrl: 'https://images.unsplash.com/photo-1567332768567-0c7da79c53c4?auto=format&fit=crop&w=600&q=80' },
        { code: 'GLS-009', vendor: '에잇핀', name: '안경 진열용 트레이 (12구)', price: 15000, imageUrl: 'https://images.unsplash.com/photo-1509695507497-903c140c43b0?auto=format&fit=crop&w=600&q=80' },
        { code: 'GLS-010', vendor: '에잇핀', name: '초음파 세척기 (산업용 소형)', price: 150000, imageUrl: 'https://images.unsplash.com/photo-1635763957245-0d2d3460662d?auto=format&fit=crop&w=600&q=80' }
    ]
};

// 3. 서브 컴포넌트들
const ProductModal = ({ product, onClose, onConfirm }) => {
    const [qty, setQty] = useState(1);

    if (!product) return null;

    const total = product.price * qty;

    const handleConfirm = () => {
        if (qty < 1) {
            alert("수량은 1개 이상이어야 합니다.");
            return;
        }
        onConfirm(product, qty, total);
    };

    return (
        <div className="modal-overlay">
            <div className="modal">
                <div className="modal-header">
                    <div className="modal-title">상세 내역 및 주문</div>
                    <div className="close-btn" onClick={onClose}>×</div>
                </div>
                <div className="modal-body">
                    <div className="modal-image-container">
                        <img
                            src={product.imageUrl}
                            alt={product.name}
                            onError={(e) => {e.target.src = 'https://placehold.co/500x300?text=No+Image';}}
                        />
                    </div>

                    <div className="info-row"><span className="label">품목코드</span> <span className="value">{product.code}</span></div>
                    <div className="info-row"><span className="label">품명</span> <span className="value">{product.name}</span></div>
                    <div className="info-row"><span className="label">단가</span> <span className="value">{product.price.toLocaleString()} 원</span></div>

                    <div className="input-group">
                        <label>주문 수량</label>
                        <input
                            type="number"
                            className="input-qty"
                            value={qty}
                            min="1"
                            onChange={(e) => setQty(Number(e.target.value))}
                        />
                    </div>

                    <div className="total-price-area">
                        총 금액: <span>{total.toLocaleString()}</span>원
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="btn-full btn-cancel" onClick={onClose}>취소</button>
                    <button className="btn-full btn-confirm" onClick={handleConfirm}>주문하기</button>
                </div>
            </div>
        </div>
    );
};

const OrderSheetModal = ({ orders, onClose, onFinalConfirm }) => {
    const grandTotal = orders.reduce((acc, cur) => acc + cur.total, 0);

    return (
        <div className="modal-overlay">
            <div className="modal large">
                <div className="modal-header">
                    <div className="modal-title">주문서 미리보기 (Order Sheet)</div>
                    <div className="close-btn" onClick={onClose}>×</div>
                </div>
                <div className="modal-body">
                    <div style={{ marginBottom: '20px', fontSize: '14px', color: '#555', lineHeight: '1.6' }}>
                        <p><strong>수신:</strong> 8pin@8pin.co.kr (담당자 앞)</p>
                        <p><strong>발신:</strong> iMOS 고객사</p>
                        <p><strong>일자:</strong> {new Date().toLocaleDateString()}</p>
                    </div>
                    <table className="invoice-table">
                        <thead>
                        <tr>
                            <th>품명</th>
                            <th width="15%">수량</th>
                            <th width="20%">단가</th>
                            <th width="25%">금액</th>
                        </tr>
                        </thead>
                        <tbody>
                        {orders.map((order) => (
                            <tr key={order.id}>
                                <td style={{ textAlign: 'left', paddingLeft: '16px' }}>{order.name}</td>
                                <td>{order.qty}</td>
                                <td>{order.price.toLocaleString()}</td>
                                <td>{order.total.toLocaleString()}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <div className="invoice-summary">
                        총 합계: <span style={{ color: '#3b82f6' }}>{grandTotal.toLocaleString()}원</span>
                    </div>
                    <p style={{ marginTop: '20px', fontSize: '14px', color: '#888', textAlign: 'center' }}>
                        * 위 내용으로 주문을 확정하시겠습니까?
                    </p>
                </div>
                <div className="modal-footer">
                    <button className="btn-full btn-cancel" onClick={onClose}>닫기</button>
                    <button className="btn-full btn-confirm" onClick={onFinalConfirm}>확정 및 메일 발송</button>
                </div>
            </div>
        </div>
    );
};

// 4. 메인 컴포넌트
const GroupPurchaseManagement = () => {
    const [currentCategory, setCurrentCategory] = useState('print');
    const [orders, setOrders] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [isOrderSheetOpen, setIsOrderSheetOpen] = useState(false);

    // 모달 관련 상태
    const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);

    const productList = useMemo(() => PRODUCTS_DATA[currentCategory], [currentCategory]);

    const handleAddToOrder = (product, qty, total) => {
        const newOrder = {
            id: `ORD-${1000 + orders.length + 1}`,
            ...product,
            qty,
            total
        };
        setOrders([...orders, newOrder].reverse());
        setSelectedProduct(null);
    };

    const handleFinalConfirm = () => {
        alert(`[메일 발송 완료]\n\n수신자: 8pin@8pin.co.kr\n내용: 주문서가 성공적으로 발송되었습니다.\n\n담당자가 확인 후 연락드리겠습니다.`);
        setOrders([]);
        setIsOrderSheetOpen(false);
    };

    return (
        <>
            {/* 스타일 주입 */}
            <style>{globalStyles}</style>

            <div className="app-container">
                <main>
                    <header>
                        <PageHeader
                            title="공동 구매"
                            setIsHelpModalOpen={setIsHelpModalOpen}
                            domain={"domain"}
                        />

                        <button className="btn-order-header" onClick={() => alert('상품 등록 기능 준비중입니다.')}>+ 물품 등록하기</button>
                    </header>

                    <div className="category-tabs">
                        <button
                            className={`tab-btn ${currentCategory === 'print' ? 'active' : ''}`}
                            onClick={() => setCurrentCategory('print')}
                        >
                            인쇄업종
                        </button>
                        <button
                            className={`tab-btn ${currentCategory === 'clothes' ? 'active' : ''}`}
                            onClick={() => setCurrentCategory('clothes')}
                        >
                            의류제작
                        </button>
                        <button
                            className={`tab-btn ${currentCategory === 'glasses' ? 'active' : ''}`}
                            onClick={() => setCurrentCategory('glasses')}
                        >
                            안경제작
                        </button>
                    </div>

                    <div className="card">
                        <h3 style={{ marginBottom: '16px', fontSize: '18px', color: '#1f2937' }}>구매 가능 목록</h3>
                        <table>
                            <colgroup>
                                <col width="10%" />
                                <col width="15%" />
                                <col width="*" />
                                <col width="15%" />
                                <col width="10%" />
                                <col width="10%" />
                            </colgroup>
                            <thead>
                            <tr>
                                <th>코드</th>
                                <th>업체명</th>
                                <th>품목명</th>
                                <th>단가(원)</th>
                                <th>상태</th>
                                <th>관리</th>
                            </tr>
                            </thead>
                            <tbody>
                            {productList.map((item) => (
                                <tr key={item.code} onClick={() => setSelectedProduct(item)}>
                                    <td style={{ color: '#6b7280' }}>{item.code}</td>
                                    <td>{item.vendor}</td>
                                    <td style={{ fontWeight: '600', color: '#111827' }}>{item.name}</td>
                                    <td style={{ fontWeight: '500' }}>{item.price.toLocaleString()}</td>
                                    <td><span className="status-badge">구매가능</span></td>
                                    <td><button className="btn-order">상세보기</button></td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="card my-order-list">
                        <h3 style={{ marginBottom: '16px', fontSize: '18px', color: '#1f2937' }}>나의 신청 목록 (주문 현황)</h3>
                        <table id="order-table">
                            <colgroup>
                                <col width="15%" />
                                <col width="*" />
                                <col width="10%" />
                                <col width="15%" />
                                <col width="15%" />
                            </colgroup>
                            <thead>
                            <tr>
                                <th>주문번호</th>
                                <th>품목명</th>
                                <th>수량</th>
                                <th>총 금액</th>
                                <th>상태</th>
                            </tr>
                            </thead>
                            <tbody>
                            {orders.length === 0 ? (
                                <tr>
                                    <td colSpan="5" className="empty-msg">아직 주문한 내역이 없습니다.</td>
                                </tr>
                            ) : (
                                orders.map((order) => (
                                    <tr key={order.id}>
                                        <td style={{ color: '#6b7280' }}>{order.id}</td>
                                        <td style={{ fontWeight: '500' }}>{order.name}</td>
                                        <td>{order.qty}</td>
                                        <td style={{ fontWeight: 'bold', color: '#3b82f6' }}>{order.total.toLocaleString()}원</td>
                                        <td><span className="status-badge" style={{ background: '#dbeafe', color: '#1e40af' }}>신청완료</span></td>
                                    </tr>
                                ))
                            )}
                            </tbody>
                        </table>
                        <div className="order-action-area">
                            <button
                                className="btn-final-order"
                                onClick={() => {
                                    if(orders.length === 0) alert("주문할 내역이 없습니다.");
                                    else setIsOrderSheetOpen(true);
                                }}
                            >
                                주문 확정
                            </button>
                        </div>
                    </div>
                </main>

                {selectedProduct && (
                    <ProductModal
                        product={selectedProduct}
                        onClose={() => setSelectedProduct(null)}
                        onConfirm={handleAddToOrder}
                    />
                )}

                {isOrderSheetOpen && (
                    <OrderSheetModal
                        orders={orders}
                        onClose={() => setIsOrderSheetOpen(false)}
                        onFinalConfirm={handleFinalConfirm}
                    />
                )}
            </div>
        </>
    );
};

export default GroupPurchaseManagement;